import { Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Private from "../../Components/Private"

import "./EnrollmentDescriptorCard.less"

const { Text } = Typography

const EnrollmentBinCaidCodesCard = ({ enrollment }) => {
  const { t } = useTranslation()

  // Function to get BIN/CAID code pairs with proper alignment
  const getBinCaidPairs = () => {
    const binCodes = enrollment?.visa_bin_codes || []
    const caidCodes = enrollment?.visa_caid_codes || []
    const maxLength = Math.max(binCodes.length, caidCodes.length)

    const pairs = []

    // Create pairs - if one code is missing, use long dash
    for (let i = 0; i < maxLength; i++) {
      pairs.push({
        binCode: binCodes[i] || "—", // Long dash if no BIN code
        caidCode: caidCodes[i] || "—" // Long dash if no CAID code
      })
    }

    return pairs
  }

  const binCaidPairs = getBinCaidPairs()

  return (
    <div
      className={cls("enrollment-descriptors-status-card", {
        "enrollment-descriptors-status-card_arn": true,
        "enrollment-descriptors-status-card_admin": true
      })}
    >
      <div className={"enrollment-descriptors-status-card-header"}>
        <Text type="secondary">{t("BIN/CAID codes")}</Text>
      </div>
      <div className={cls("enrollment-descriptors-status-card-body")}>
        <Flex gap={16} style={{ marginTop: "8px" }}>
          {/* BIN Codes Column */}
          <div style={{ flex: 1 }}>
            <Flex gap={4} vertical>
              {binCaidPairs.map((pair, index) => (
                <div key={index} style={{ padding: "4px 8px" }}>
                  <Private>{pair.binCode}</Private>
                </div>
              ))}
            </Flex>
          </div>

          {/* CAID Codes Column */}
          <div style={{ flex: 1 }}>
            <Flex gap={4} vertical>
              {binCaidPairs.map((pair, index) => (
                <div key={index} style={{ padding: "4px 8px" }}>
                  <Private>{pair.caidCode}</Private>
                </div>
              ))}
            </Flex>
          </div>
        </Flex>
      </div>
    </div>
  )
}

export default EnrollmentBinCaidCodesCard
